import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Link } from "react-router-dom";
import { Row, Col, Button } from 'react-bootstrap';
import SitagLogo from '../../../../styles/images/sitag-logo.png';
import CloseIcon from '../../../../styles/images/close.png';
import MenuItems from './menu_item';

const NeedLogin = () => {

    const navigate = useNavigate();

    const handleBackBtn = () => {
        navigate('/', { replace: true });
    };

    return (

        <div id="need-login-page">

                    

            <Row className="pt-4 header_h4">
                <Col xs={12} className="text-center">
                    <Row className="white-bg pb-3 ">
                        <Col xs={2}></Col>
                        <Col xs={8} className="d-flex align-items-center justify-content-center">
                            <img src={SitagLogo} className="logo-header" alt="سیتگ" />
                        </Col>
                        <Col xs={2} className="d-flex align-items-center"><img src={CloseIcon} alt="back" onClick={handleBackBtn} role="button" /></Col>
                    </Row>
                </Col>
                <Col xs={12} className="text-center mt-4">
                    برای استفاده از خدمات سیتگ
                </Col>
                <Col xs={12} className="text-center">
                    وارد حساب کاربری خود شوید
                </Col>
            </Row>

            <Row>
                <Col className="text-center mt-4">
                    <Link to="../login">
                        <Button className="primary-btn px-4 py-2">
                            ورود / ثبت نام
                        </Button>
                    </Link>
                </Col>
            </Row>

            <MenuItems />
        </div>

    );
}

export default NeedLogin;